import { apiClient } from './apiClient'

// Types for valuation property request
export interface ValuationPropertyRequest {
  address: string
  propertyType: string
  email: string
  embedId: string
}

export interface ValuationPropertyResponse {
  success: boolean
  message?: string
  data?: any
}

/**
 * Creates a valuation property request
 * Uses the configured apiClient that already handles Bearer token automatically
 * @param data - Valuation property request data
 */
export const createValuationPropertyRequest = async (
  data: ValuationPropertyRequest
): Promise<ValuationPropertyResponse> => {
  try {
    const response = await apiClient.post(
      '/api/hq-nd/ValuationProperty/createRequest',
      data
    )
    return response.data
  } catch (error: any) {
    console.error('Error creating valuation property request:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error creating valuation property request'
    )
  }
}

export default createValuationPropertyRequest

